<template>
   <div class="edit_user" v-loading.fullscreen.lock="loading">
       <headerTab :tabList="tabList"></headerTab>
       <div class="edit_user_header">
           <img :src="user.avatar ? $imgUrl + user.avatar : defaultImg" alt="">
           <div class="edit_user_header_modal">修改头像</div>
           <input type="file" accept="image/*" @change="uploadImage" name="uploader-input" class="edit_user_header_upload" />
       </div>
       <div class="edit_user_form">
           <div class="edit_user_form_label">昵称：</div>
           <div class="edit_user_form_value">
               <el-input placeholder="请输入联系人的真实姓名" v-model="user.username"></el-input>
           </div>
       </div>
       <div class="edit_user_form">
           <div class="edit_user_form_label">绑定电话：</div>
           <div class="edit_user_form_value">
               <span class="edit_user_form_value_phone">{{user.phone | phoneFormat}}</span>
               <span>请到移动端修改</span>
           </div>
       </div>
        <el-button type="primary" size="small" @click="editSubmit">修改</el-button>
   </div>
</template>

<script>
import headerTab from '../../components/header_tab'
export default {
   data (){
       return {
           loading:false,
           tabList:[{name:'编辑资料',id:1}],
           user:{},
           defaultImg:require('../../assets/default_user.png')
       }
   },
   components: {
       headerTab
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       uploadImage(event){
           let file = event.target.files[0];
            let param = new FormData();
            param.append('file', file);
            this.loading = true;
            this.$post('UploadImage',param)
                .then(data => {
                    this.loading = false;
                    this.user.avatar = data.image_path;
                    this.$message.success('图片上传成功');
                }, error => {
                    this.loading = false;
                    this.$message.error(error);
                });
       },
       getUserInfo(){
           this.$get('UserInfo',{})
            .then(data => {
                this.user = data;
            } , error => {
                this.$message.error(error);
            });
       },
       editSubmit(){
        //    console.log();
           this.$put('userInfoUpdate',{avatar:this.user.avatar,username:this.user.username})
            .then(data => {
                this.$message.success('资料修改成功！');
                let userMessage = JSON.parse(localStorage.getItem('userMessage') || '{}');
                userMessage.username = this.user.username;
                userMessage.avatar = this.user.avatar;
                localStorage.setItem('userMessage',JSON.stringify(userMessage));
                this.$eventBus.$emit('changeUserInfo',userMessage);
            },error => {
                this.$message.error(error);
            });
       }
   },
   created() {
       this.getUserInfo();
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.edit_user{
    /deep/ .el-button{
        font-size: 18px;
        font-weight: normal;
        width: 104px;
        margin-top:100px;
        margin-left: 8px;
    }
    &_header{
        display: inline-block;
        width:90px;
        height: 90px;
        border-radius: 45px;
        margin: 40px 0 30px 150px ;
        position: relative;
        cursor: pointer;
        &_modal{
            width: 90px;
            height: 90px;
            line-height: 90px;
            text-align: center;
            font-size: 18px;
            color:#fff;
            border-radius: 45px;
            background:rgba(0,0,0,0.5);
            position: absolute;
            top:0;
            left:0;
            z-index: 1;
            
        }
        &_upload{
            position: absolute;
            left: 0;
            right: 0;
            width:90px;
            height: 90px;
            border-radius: 45px;
            opacity: 0;
            z-index: 2;
            cursor: pointer;
        }
        img{
            width:90px;
            height: 90px;
            border-radius: 45px;
        }
    }
    &_form{
        display: flex;
        margin-bottom:31px;
        align-items: center;
        /deep/ .el-input__inner{
            width:300px;
            height: 36px;
            padding: 10px 12px ;
            font-size: 16px;
            border-radius: 0;
        }
        &_label{
            width:88px;
            text-align: right;
            font-size: 16px;
            color:#666;
            line-height: 22px;
        }
        &_value{
            padding-left: 6px;
            span{
                color:#999;
            }
            span.edit_user_form_value_phone{
                padding-left: 12px;
                padding-right: 8px;
                color:#333;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/editUser/editUser.vue